<script lang="ts">
	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import { LinkButton } from '../../../../components/LinkButton';
	import { extractNonNull } from '../../../../utils/extractNonNull/extractNonNull';
	import type { ArticleButtonType } from '../../types';

	interface Props {
		item: ArticleButtonType;
	}

	let { item }: Props = $props();

	let safeItem = $derived(extractNonNull(item, ['button_link', 'button_text'], {}));
</script>

{#if safeItem}
	{@const href = safeItem.button_link.startsWith('https://heni.com')
		? safeItem.button_link.split('https://heni.com')[1]
		: safeItem.button_link}

	<LinkButton
		class="article-button [&>button>span>div>p>*]:text-gray-0"
		buttonProps={{ class: 'h-auto min-h-[2.5rem]' }}
		dataCy="blog-article"
		{href}
		newTab={!href.startsWith('/')}
		size="md"
	>
		<LazyMarkdown
			dataCy="blog-article-link-button"
			source={item.buttonTextTokens ?? safeItem.button_text}
		/>
	</LinkButton>
{/if}

<style>
	:global(.article-button p) {
		color: white;
		margin-bottom: 0;
		white-space: initial;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}
</style>
